import React from 'react';

import {getPublicAccreditationBodies} from 'api/accreditation-bodies';
import {SelectSearchBase} from 'components/Forms/FormBases';

class SelectGlobalAB extends React.Component {
  static defaultProps = {
    isClearable: true,
    cacheOptions: true,
    defaultOptions: true,
    isDisabled: false,
    name: 'accreditation_bodies_id',
    placeholder: 'Accreditation Bodies',
    onChange: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      options: props.options || [],
      value: props.defaultValue || '',
      inputValue: '',
    };
  }

  componentDidMount() {
    this._isMounted = true;

    const {defaultOptions} = this.props;

    if (defaultOptions) this.loadOptions();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  loadOptions() {
    const {isDisabled} = this.props;

    if (isDisabled) return false;

    this.setState(
      {
        isLoading: true,
      },
      () => {
        const {inputValue} = this.state;

        const queries = {
          search: inputValue,
          order: 'ASC',
          order_by: 'accreditation_bodies_name',
        };

        getPublicAccreditationBodies(queries).then(({data}) => {
          if (!this._isMounted) return false; // Check Mounted
          this.setState({
            options: data,
            isLoading: false,
          });
        });
      }
    );
  }

  handleChange(data, callback) {
    this.setState({value: data}, callback(data));
  }

  render() {
    const {value, defaultOptions, onChange, ...rest} = this.props;
    return (
      <SelectSearchBase
        {...rest}
        value={this.state.value}
        options={this.state.options}
        isLoading={this.state.isLoading}
        getOptionLabel={(option) => option && option.accreditation_bodies_name}
        getOptionValue={(option) => option && option.accreditation_bodies_id}
        onChange={(obj) => this.handleChange(obj, onChange)}
      />
    );
  }
}

export default SelectGlobalAB;
